import { useTranslation } from 'react-i18next'
import { RateCard } from './RateCard'


const ScanRateCard = ({scanRate, isLoading}) => {
    const [t] = useTranslation()

    const scanPercentRate = Math.round(scanRate * 100)
    return (
      <RateCard
        cardLabel={t('dashboard.scan_rate.title')}
        chartLabel={t('dashboard.scan_rate.label')}
        rate={scanPercentRate}
        isLoading={isLoading}
      />
    )
}

export { ScanRateCard }
